import script from "./ModalCrearTorneo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalCrearTorneo.vue?vue&type=script&setup=true&lang=ts"

import "./ModalCrearTorneo.vue?vue&type=style&index=0&id=2f7c817c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f7c817c"]])

export default __exports__